export default __webpack_public_path__ + "static/media/Shashank Shekhar.fe5cfede.jfif";